module.exports = __webpack_public_path__ + "n.no1.cdaccff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/n.no1.jpg
// module id = sgmq
// module chunks = 0